import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-admin-home',
  templateUrl: './admin-home.page.html',
  styleUrls: ['./admin-home.page.scss'],
  standalone: true,
  imports: [BreadcrumbModule, CardModule]
})
export class AdminHomePage implements OnInit {

  home: MenuItem = { icon: 'pi pi-cog', label: 'Administration', routerLink: '/admin' };

  constructor() { }

  ngOnInit() {
  }

}
